<template>
    <div class="auth-wrapper auth-v2 bg-white">
        <b-row class="auth-inner m-0">
            <div class="w-100 d-flex flex-column justify-content-between">
                <HeaderBar/>
                <div class="px-1  bg-white flex-fill">
                    <div class="d-flex flex-column  mt-4 ">
                        <div class="title d-flex justify-content-center align-items-center mt-2">
                            Soporte
                        </div>
                        <div class="mb-2 mt-2 ">
                            <b-card no-body class="overflow-hidden" v-for="data in contacts"
                            style="max-width: 540px;">
                                <b-row no-gutters>
                                    <b-col >
                                        <b-card 
                                        :title="data.Región"
>
                                            <b-card-text>
                                                <p><strong>Región:</strong> {{ data.region }}</p>
                                                <p><strong>Técnico:</strong> {{ data.technician }}</p>
                                            </b-card-text>
                                            <b-button
                                                text
                                                variant="primary fill"
                                                :href="'https://wa.me/'+data.number+'?text=Solicitud de soporte desde GanApp'" target="_blank"
                                            >
                                                Solicitar soporte
                                            </b-button>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
        </b-row>
        <ControlMenu />
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import {
    BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormGroup, BFormInput, BInputGroup, BImg, BCardTitle,BCardImg, BCardText,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
    components: {
        BRow,
        ControlMenu,
        HeaderBar,
        BImg,
        BCol,
        BLink,
        BButton,
        BForm,
        BCard,
        BCardBody,
        BCardText,
        BCardTitle,
        BFormGroup,
        BFormInput,
        BInputGroup,
        // validations
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            contacts:[],

        }
    },
    methods:{
        async fetchContacts(config){
            fetch(this.$apiUrl+"list/contacts?recperpage=all", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.contacts);
                this.contacts = result.contacts;
                console.log(this.contacts);
            })
        },
    },
    mounted(){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchContacts(config);
    }

}
</script>

<style>
.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}
.headTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;

}

</style>
